import React, { useRef, useState } from "react";
import { Box, Button, IconButton, Icon, Typography } from "@mui/material";
import { Download as DownloadIcon } from "@mui/icons-material";
import LGAutocomplete from "../../atoms/Common/LGAutocomplete.tsx";
import { getPurchaseOrderList } from "../../api/purchaseOrders";
import { useSnack } from "../../services/SnakbarProvider";

const ShipmentPurchaseOrderFields = ({
  companyId,
  purchaseOrders = [],
  onAdd,
  onRemove,
  onDownload,
}) => {
  const [selectedPO, setSelectedPO] = useState(null);
  const { openSnack } = useSnack();
  const assignedIdsRef = useRef(new Set());

  assignedIdsRef.current = new Set(
    purchaseOrders.map((po) => po.purchaseOrderId),
  );

  const fetchPurchaseOrders = async (params) => {
    const response = await getPurchaseOrderList(params);
    const data = Array.isArray(response.data) ? response.data : [];
    return {
      ...response,
      data: data.filter((po) => !assignedIdsRef.current.has(po.id)),
    };
  };

  const handleAdd = () => {
    if (!selectedPO) return;

    if (assignedIdsRef.current.has(selectedPO.id)) {
      openSnack("Esta orden de compra ya está agregada", "warning");
      return;
    }

    onAdd({
      id: 0,
      purchaseOrderId: selectedPO.id,
      purchaseOrder: selectedPO,
    });
    setSelectedPO(null);
  };

  return (
    <>
      <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
        <Box sx={{ flexGrow: 1 }}>
          <LGAutocomplete
            fetchFunction={fetchPurchaseOrders}
            queryParams={{
              companyId,
              isImport: true,
            }}
            optionLabel="code"
            value={selectedPO}
            onChange={(_event, value) => setSelectedPO(value)}
            label="Orden de compra"
          />
        </Box>
        <Button
          type="button"
          variant="outlined"
          onClick={handleAdd}
          disabled={!selectedPO}
          sx={{ whiteSpace: "nowrap" }}
        >
          Agregar
        </Button>
      </Box>
      {purchaseOrders.map((po) => (
        <Box
          key={po.purchaseOrderId}
          sx={{
            mb: 2,
            p: 2,
            border: "1px solid",
            borderColor: "divider",
            borderRadius: 1,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="subtitle1">
            {po.purchaseOrder?.code || `PO ${po.purchaseOrderId}`}
          </Typography>
          <Box>
            {onDownload && (
              <IconButton
                color="primary"
                size="small"
                onClick={() => onDownload(po.purchaseOrderId)}
                aria-label="Descargar orden de compra"
              >
                <DownloadIcon />
              </IconButton>
            )}
            <IconButton
              color="error"
              size="small"
              onClick={() => onRemove(po.purchaseOrderId)}
              aria-label="Eliminar orden de compra"
            >
              <Icon>delete</Icon>
            </IconButton>
          </Box>
        </Box>
      ))}
    </>
  );
};

export default ShipmentPurchaseOrderFields;
